import { useEffect, useRef } from 'react'
import { SDrawerOrModal, SGeneralForms, SLocalTreeSelected } from 'shj-components'
import { channelCategoryInsert, channelCategoryUpdateById, getChannelCategory } from "@/services/channelManagement";
import { message } from "antd";
import { trimStr } from "@/utils/data.ts";
interface IAddOrEditProps {
  channelCategoryData:[]
  title?: string
  open?: boolean
  record?: any
  reload?: (values?: object, res?: any) => void
  onClose?: (values?: object) => void
}

export default function AddOrEdit(props: IAddOrEditProps) {
  const { open = false, record, channelCategoryData, reload, onClose } = props;
  const formRef = useRef<any>()
  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }
  useEffect(() => {
    if (open) {
      record?.id && fetchDetail()
    } else {
      onFormRef()?.resetFields()
    }
  }, [open, record])

  const fetchDetail = () => {
    getChannelCategory(record?.id).then((res: any) => {
      console.log('res', res);
      const newObj = res || {};
      newObj.parentId = newObj.parentId && newObj.parentId + '';
      formRef.current?.onFormRef()?.setFieldsValue({ ...newObj, enabled: !!newObj.enabled });
    });
  };

  const httpOptionsFn = (): Promise<Record<string, any>> => {
    return new Promise((resolve) => {
      resolve({ ...record })
    })
  };

  const onFinish = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      formRef.current?.onFormRef()?.validateFields()
        .then((values) => {
          const apiFn = values.id ? channelCategoryUpdateById : channelCategoryInsert
          apiFn({ ...values, enabled: !!values.enabled }).then(() => {
            message.success('操作成功');
            onClose?.()
            reload?.()
            resolve();
          }).catch(reject);
        })
        .catch(reject);
    });
  };

  return (
    <SDrawerOrModal
      title={record?.id ? '编辑' : '新增'}
      open={open}
      onOk={onFinish}
      onCancel={onClose}
    >
      <SGeneralForms
        initialValues={{ enabled: false }}
        httpOptionsFn={httpOptionsFn}
        ref={formRef}
        layout={'vertical'}
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '名称', name: 'categoryName', spanCol: 24, required: true,
                comConfig: {
                  showCount: true,
                  maxLength: 20,
                  onChange: (v) => formRef.current?.onFormRef().setFieldValue('categoryName', trimStr(v.target.value))
                }
              },
              {
                label: '排序',
                name: 'sortNumber', spanCol: 24,
                rules: [{ required: false, message: '请输入大于或等于0的整数', pattern: /^[0-9]\d*$/ }]
              },
              { label: '是否有效', name: 'enabled', spanCol: 24, type: 'switch', valuePropName: 'checked' },
              {
                label: '父节点',
                name: 'parentId', spanCol: 24,
                required: true,
                children: <SLocalTreeSelected treeData={channelCategoryData}
                  fieldNames={{ label: 'label', value: 'id' }} />
              },
              {
                label: '描述', name: 'description', spanCol: 24, type: 'textarea', required: true,
                comConfig: {
                  showCount: true,
                  maxLength: 200,
                  onChange: (e) => formRef.current?.onFormRef()?.setFieldValue('description', trimStr(e.target.value))
                }
              },
            ]
          }
        ]}
      />
    </SDrawerOrModal>
  )
}
